import moment from 'moment'
import {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../../../modules/auth/core/Auth'
import {AuthModel, UserModel} from '../../../modules/auth/core/_models'
import {getUserByToken, login} from '../../../modules/auth/core/_requests'
import {ClaimLinkWidget} from '../../../modules/futurisk/claim/ClaimLinkWidget'
import {DocumentLinkWidget} from '../../../modules/futurisk/DocumentLinkWidget'
import {LinkWidget} from '../../../modules/futurisk/LinkWidget'
import {DashboardLinkWidget} from '../../../modules/futurisk/DashboardLinkWidget'
import {MidTermLinkWidget} from '../../../modules/futurisk/midterm/MidTermLinkWidget'
import {FamilyDetailsLinkWidget} from '../../../modules/futurisk/familyDetails/FamilyDetailsLinkWidget'
import {OnityEnrollmentListWidget} from '../../../modules/futurisk/OnityEnrollment/OnityEnrollmentListWidget'
import {OnityEnrollmentLinkWidget} from '../../../modules/futurisk/OnityEnrollment/OnityEnrollmentLinkWidget'

import {AcsGlobalBaseEnrollmentLinkWidget} from '../../../modules/futurisk/AcsGlobalBaseEnrollment/AcsGlobalBaseEnrollmentLinkWidget'
import {AcsGlobalParentalEnrollmentLinkWidget} from '../../../modules/futurisk/AcsGlobalParentalEnrollment/AcsGlobalParentalEnrollmentLinkWidget'
import {PaltechbaseEnrollmentLinkWidget} from '../../../modules/futurisk/Paltechbaseenrollment/PaltechbaseEnrollmentLinkWidget'
import {McxBaseEnrollmentLinkWidget} from '../../../modules/futurisk/McxBaseEnrollment/McxBaseEnrollmentLinkWidget'
import {McxParentalEnrollmentLinkWidget} from '../../../modules/futurisk/McxParentalEnrollment/McxParentalEnrollmentLinkWidget'
import {WilliamsleaBaseEnrollmentLinkWidget} from '../../../modules/futurisk/WilliamsleaBaseEnrollment/WilliamsleaBaseEnrollmentLinkWidget'
import {WilliamsleaParentalEnrollmentLinkWidget} from '../../../modules/futurisk/WilliamsleaParentalEnrollment/WilliamsleaParentalEnrollmentLinkWidget'
import {TaskusBaseEnrollmentLinkWidget} from '../../../modules/futurisk/TaskusBaseEnrollment/TaskusBaseEnrollmentLinkWidget'
import {UnifiedEnrollmentLinkWidget} from '../../../modules/futurisk/Enroll/UnifiedEnrollment'
import { ClaimHubLinkWidget } from '../../../modules/futurisk/claimshub/ClaimHubLinkWidget'

export function Policy() {
  const [currentUser, setItems] = useState({} as UserModel)
  const [isLoaded, setIsLoaded] = useState(false)
  const [error] = useState(null)
  const [refreshKey, setRefreshKey] = useState(0)
  const clientid = useAuth().currentUser?.CRMClientId
  const email = useAuth().currentUser?.Email
  const a: AuthModel | undefined = useAuth().auth
  //setItems(useAuth().currentUser);
  const auth: AuthModel = login(a?.username!, a?.password!, 'mypolicy')

  const handleRefresh = () => setRefreshKey((prev) => prev + 1)

  useEffect(() => {
    ;(async () => {
      var data = await getUserByToken(auth)
      if (data.data.Status === 'Success') {
        //setCurrentUser(data.data);
        setItems(data.data)
        setIsLoaded(true)
      }
    })()
  }, [refreshKey])
  if (error) {
    return (
      <>
        <div className='d-flex flex-column flex-root'></div>
        <div id='splash-screen' className='splash-screen'>
          <img
            src='media/futuriskicon/ms-icon-310x310.png'
            alt='Futurisk logo'
            className='h-150px'
          />
          <span>Loading ...</span>
        </div>
      </>
    )
  } else if (!isLoaded) {
    return (
      <div className='row g-5 g-xl-8 my-5'>
        <div
          className='card shadow mb-5 mb-xl-5 bgi-no-repeat'
          style={{
            backgroundPosition: 'right top',
            backgroundSize: '30% auto',
            backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
          }}
        >
          <div className='card-body pt-9 pb-9'>
            <span>Personalizing Your Dashboard ...</span>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <>
        {clientid !== 964 && (
          <div className='row g-5 g-xl-8'>
            {currentUser?.MyPolicies.map((policy, index) => {
              return (
                <div
                  className='card shadow mb-5 mb-xl-5 bgi-no-repeat'
                  style={{
                    //background: 'linear-gradient(112.14deg, #00D2FF 0%, #3A7BD5 100%)',
                    backgroundPosition: 'top right',
                    backgroundSize: '105% auto',
                    backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
                  }}
                  key={index}
                >
                  <div className='row'>
                    <div className='col-xl-12'>
                      <div className={`mx-5 py-5`}>
                        <div className='d-flex flex-stack'>
                          <h4 className='m-0 fw-bolder fs-5'>{policy.Policy.PolicyType}</h4>
                        </div>
                      </div>
                    </div>

                    <div className='col-xl-8'>
                      <div className='table-responsive mx-5'>
                        {/* begin::Table */}
                        <table className='table table-row-gray-300 align-middle gs-0 gy-1'>
                          {/* begin::Table body */}
                          <tbody>
                            <tr style={{textTransform: 'capitalize'}}>
                              <td>
                                <span className='text-dark fw-bolder text-hover-primary d-block fs-7'>
                                  Insurer :
                                </span>
                              </td>

                              <td>
                                <span className='text-dark fw-bolder text-hover-primary d-block fs-7 '>
                                  {policy.Policy.InsurerInsurerName}
                                </span>
                              </td>
                            </tr>
                            {![7, 9].includes(policy.Policy.PolicyTypeId) && (
                              <tr style={{textTransform: 'capitalize'}}>
                                <td>
                                  <span className='text-dark fw-bolder text-hover-primary d-block fs-7'>
                                    TPA :
                                  </span>
                                </td>

                                <td>
                                  <span className='text-dark fw-bolder text-hover-primary d-block fs-7 '>
                                    {policy.Policy.TpaidThirdPartyAdministratorName}
                                  </span>
                                </td>
                              </tr>
                            )}
                            <tr style={{textTransform: 'capitalize'}}>
                              <td>
                                <span className='text-dark fw-bolder text-hover-primary d-block fs-7'>
                                  Policy Period :
                                </span>
                              </td>

                              <td>
                                <span className='text-dark fw-bolder text-hover-primary d-block fs-7 '>
                                  {moment(policy.Policy.PolicyEffectiveDate).format('DD-MM-YYYY')}{' '}
                                  to &nbsp;
                                  {moment(policy.Policy.ExpiryDate).format('DD-MM-YYYY')}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {![
                      'FIB00001219C',
                      'FIB00001218C',
                      'FIB00001217C',
                      'FIB00001156C',
                      'FIB0000869C',
                      'FIB0000870C',
                      'FIB0000866C',
                      'FIB0000873C',
                      'FIB0000862C',
                      'FIB00001229C'
                    ].includes(policy.Policy.CrmDbName) &&
                      currentUser?.DBType !== '4' &&
                      policy.Policy.PolicyTypeId === 1 && (
                        <div className='col-xl-4'>
                          {currentUser!.CRMUrl?.Url !== '' && (
                            <DashboardLinkWidget
                              className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border mx-5 mb-5'
                              avatar='crm.png'
                              title={'Enroll Family'}
                              description={currentUser!.CRMUrl?.Description!}
                              link={currentUser!.CRMUrl?.Url}
                            />
                          )}
                        </div>
                      )}

                    {}

                    <div className=' d-flex flex-wrap mx-5'>
                      <div className='col-md-6 col-sm-6 col-lg-6 col-xl-3'>
                        {['FIB00001219C', 'FIB00001218C', 'FIB00001217C'].includes(
                          policy.Policy.CrmDbName
                        ) && (
                          <PaltechbaseEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                          ></PaltechbaseEnrollmentLinkWidget>
                        )}
                        {policy.Policy.CrmDbName === 'FIB0000869C' && (
                          <AcsGlobalBaseEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></AcsGlobalBaseEnrollmentLinkWidget>
                        )}
                        {policy.Policy.CrmDbName === 'FIB0000866C' && (
                          <AcsGlobalBaseEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></AcsGlobalBaseEnrollmentLinkWidget>
                        )}
                        {policy.Policy.CrmDbName === 'FIB0000873C' && (
                          <AcsGlobalBaseEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></AcsGlobalBaseEnrollmentLinkWidget>
                        )}


                        {policy.Policy.CrmDbName === 'FIB0000870C' && (
                          <AcsGlobalParentalEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></AcsGlobalParentalEnrollmentLinkWidget>
                        )}

                        {policy.Policy.CrmDbName === 'FIB0000867C' && (
                          <AcsGlobalParentalEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></AcsGlobalParentalEnrollmentLinkWidget>
                        )}
                        {policy.Policy.CrmDbName === 'FIB0000862C' && (
                          <AcsGlobalParentalEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></AcsGlobalParentalEnrollmentLinkWidget>
                        )}
                        {policy.Policy.CrmDbName === 'FIB00001229C' && (
                          <McxParentalEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></McxParentalEnrollmentLinkWidget>
                        )}
                        {policy.Policy.CrmDbName === 'FIB00001156C' && (
                          <OnityEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                          ></OnityEnrollmentLinkWidget>
                        )}
                        {currentUser?.DBType === '4' && (
                          <UnifiedEnrollmentLinkWidget
                            className={''}
                            title={'Family Details'}
                            description={''}
                            avatar={''}
                            Email={email}
                            CrmUrl={currentUser?.CRMUrl?.Url}
                            MyPolicy={policy}
                            onRefresh={handleRefresh}
                          ></UnifiedEnrollmentLinkWidget>
                        )}
                        {![
                          'FIB00001219C',
                          'FIB00001218C',
                          'FIB00001217C',
                          'FIB00001156C',
                          'FIB0000869C',
                          'FIB0000870C',
                          'FIB0000866C',
                          'FIB0000873C',
                          'FIB0000862C',
                          'FIB0000867C',
                          'FIB00001229C',
                        ].includes(policy.Policy.CrmDbName) &&
                          currentUser?.DBType !== '4' && (
                            <FamilyDetailsLinkWidget
                              className={''}
                              title={'Family Details'}
                              description={''}
                              avatar={''}
                              Email={email}
                              CrmUrl={currentUser?.CRMUrl?.Url}
                              MyPolicy={policy}
                            ></FamilyDetailsLinkWidget>
                          )}
                      </div>
                      <div className='col-md-6 col-sm-6 col-lg-6 col-xl-3'>
                        <DocumentLinkWidget
                          className={''}
                          title={'Documents'}
                          description={''}
                          avatar={''}
                          link={undefined}
                          Documents={policy.Documents}
                        ></DocumentLinkWidget>
                      </div>
                      {![7, 9].includes(policy.Policy.PolicyTypeId) && (
                        <div className='col-md-6 col-sm-6 col-lg-6 col-xl-3'>
                          <ClaimLinkWidget
                            className={''}
                            title={'Claims'}
                            description={''}
                            avatar={''}
                            link={undefined}
                            Claim={policy.Claims}
                          ></ClaimLinkWidget>
                        </div>
                      )}

                      {![7, 9].includes(policy.Policy.PolicyTypeId) && (
                        <div className='col-md-6 col-sm-6 col-lg-6 col-xl-3'>
                          <LinkWidget title={'Ecard'} link={policy.EcardUrl}></LinkWidget>
                        </div>
                      )}
                      {![7, 9].includes(policy.Policy.PolicyTypeId) && (
                        <div className='col-md-6 col-sm-6 col-lg-6 col-xl-4'>
                          <LinkWidget
                            title={'Network hospital'}
                            link={policy.NetworkHospitalUrl}
                          ></LinkWidget>
                        </div>
                      )}

                      <div className='col-md-6 col-sm-6 col-lg-6 col-xl-4'>
                        {policy.Policy.PolicyTypeId === 1 && <MidTermLinkWidget />}
                      </div>

                      {policy.claimSubmissionUrl !== '' && (
                        <div className='col-md-6 col-sm-6 col-lg-6 col-xl-4'>
                          <LinkWidget
                            title={'Claim Submission'}
                            link={policy.claimSubmissionUrl}
                          ></LinkWidget>
                        </div>
                      )}

                      <div className='col-md-6 col-sm-6 col-lg-6 col-xl-4'>
                        {policy.Policy.CrmDbName === 'FIB00001000C' && (
                          <ClaimHubLinkWidget
                          className={''}
                          title={'Claims Intimation / Submission'}
                          description={''}
                          avatar={''}
                          policy={policy}
                          link={undefined}
                        />
                        )}
                      </div>
                    </div>
                    <div className='d-flex flex-wrap mx-5'></div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </>
    )
  }
}
